// ── Service de History (núcleo/aplicação) ─────────────────────────
// Regras/validações do domínio. Recebe o repositório via porta (DI) — não
// conhece Supabase. A timeline do lead + notas manuais; eventos automáticos
// são gerados por triggers no banco (trg_log_card_stage_change, etc.).
// As funções puras (mapa de metadados) ficam exportadas direto do módulo.

import type { HistoryEntry, HistoryTypeMeta } from '@/types/history';
import type {
  IHistoryRepository,
  AddHistoryNoteParams,
} from '../ports/IHistoryRepository';

// ─── Funções puras (sem repositório) ────────────────────────────
export const HISTORY_TYPE_META: Record<string, HistoryTypeMeta> = {
  stage_changed:     { icon: 'shuffle', label: 'Mudanca de etapa' },
  card_lost:         { icon: 'x',  label: 'Perda registrada' },
  activity_done:     { icon: 'check',  label: 'Atividade concluida' },
  activity_cancelled:{ icon: 'circle-x',  label: 'Atividade cancelada' },
  note_added:        { icon: 'note', label: 'Nota' },
  meeting_scheduled: { icon: 'calendar', label: 'Reuniao agendada' },
  meeting_done:      { icon: 'handshake', label: 'Reuniao realizada' },
  lead_created:      { icon: 'sparkles', label: 'Lead criado' },
};

export const getHistoryTypeMeta = (type: string): HistoryTypeMeta =>
  HISTORY_TYPE_META[type] || { icon: 'dot', label: type };

// ─── Service com dependência do repositório ─────────────────────
export class HistoryService {
  constructor(private readonly repo: IHistoryRepository) {}

  listHistoryByLead = (leadId: string | null | undefined): Promise<HistoryEntry[]> => {
    if (!leadId) return Promise.resolve([]);
    return this.repo.listByLead(leadId);
  };

  addHistoryNote = (params: AddHistoryNoteParams): Promise<HistoryEntry> => {
    if (!params?.workspaceId) throw new Error('workspaceId obrigatorio.');
    if (!params?.leadId)      throw new Error('leadId obrigatorio.');
    if (!params?.text?.trim()) throw new Error('Nota vazia.');
    return this.repo.addNote(params);
  };
}
